import { render, staticRenderFns } from "./LearnSoccer.vue?vue&type=template&id=11d2bf6e&scoped=true&"
import script from "./LearnSoccer.vue?vue&type=script&lang=js&"
export * from "./LearnSoccer.vue?vue&type=script&lang=js&"
import style0 from "./LearnSoccer.vue?vue&type=style&index=0&id=11d2bf6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d2bf6e",
  null
  
)

export default component.exports